var _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.145,
    height: 47.442,
    viewBox: "0 0 41.145 47.442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,52H36.076v3.359a3.359,3.359,0,0,1-3.359,3.359H29.359A3.359,3.359,0,0,1,26,55.359Z",
    transform: "translate(-10.466 -11.275)",
    fill: "#176eb5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6,17.038a2.487,2.487,0,0,1,.84.155V12A13.435,13.435,0,0,0,16,25.435h5.193a2.487,2.487,0,0,0-.155.84,2.519,2.519,0,0,0,5.038,0,2.487,2.487,0,0,0-.155-.84h3.513V21.922a2.487,2.487,0,0,1-.84.155,2.519,2.519,0,1,1,0-5.038Z",
    transform: "translate(-8.863 -4.863)",
    fill: "#e5b65e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.275,31.359a2.487,2.487,0,0,0-.84.155V28H25.922a2.487,2.487,0,0,1,.155.84,2.519,2.519,0,0,1-5.038,0,2.487,2.487,0,0,1,.155-.84H16a13.435,13.435,0,0,0,8.4,12.449v2.665h5.038V36.242a2.487,2.487,0,0,0,.84.154,2.519,2.519,0,1,0,0-5.038Z",
    transform: "translate(-8.863 -7.428)",
    fill: "#fbdb75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.242,27.359a2.487,2.487,0,0,0,.155-.84,2.519,2.519,0,0,0-5.038,0,2.487,2.487,0,0,0,.155.84H32v3.513a2.487,2.487,0,0,1,.84-.155,2.519,2.519,0,0,1,0,5.038A2.487,2.487,0,0,1,32,35.6v6.872h5.038V39.808a13.435,13.435,0,0,0,8.4-12.449Z",
    transform: "translate(-11.428 -6.786)",
    fill: "#e5b65e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.872,17.435a2.487,2.487,0,0,1-.155-.84,2.519,2.519,0,0,1,5.038,0,2.487,2.487,0,0,1-.155.84h5.193A13.435,13.435,0,0,0,39.359,4V9.193a2.487,2.487,0,0,0-.84-.155,2.519,2.519,0,1,0,0,5.038,2.487,2.487,0,0,0,.84-.155v3.513Z",
    transform: "translate(-12.069 -3.58)",
    fill: "#e5b65e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.92,7.7a.42.42,0,0,1-.42-.42V3.92a.42.42,0,0,1,.84,0V7.279A.42.42,0,0,1,31.92,7.7Z",
    transform: "translate(-11.347 -3.5)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,10.464a.42.42,0,0,1-.364-.21L19.556,7.346a.42.42,0,1,1,.727-.42l1.679,2.909a.42.42,0,0,1-.364.63Z",
    transform: "translate(-9.424 -4.016)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.044,18.019a.41.41,0,0,1-.209-.056l-2.91-1.679a.42.42,0,1,1,.42-.727l2.91,1.679a.42.42,0,0,1-.211.783Z",
    transform: "translate(-8.015 -5.424)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.279,28.34H7.92a.42.42,0,0,1,0-.84h3.359a.42.42,0,0,1,0,.84Z",
    transform: "translate(-7.5 -7.347)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.136,40.019a.42.42,0,0,1-.211-.783l2.91-1.679a.42.42,0,1,1,.42.727l-2.91,1.679A.41.41,0,0,1,11.136,40.019Z",
    transform: "translate(-8.015 -8.951)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.149,40.019a.41.41,0,0,1-.209-.056l-2.91-1.679a.42.42,0,1,1,.42-.727l2.91,1.679a.42.42,0,0,1-.211.783Z",
    transform: "translate(-14.124 -8.951)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.279,28.34H51.92a.42.42,0,1,1,0-.84h3.359a.42.42,0,1,1,0,.84Z",
    transform: "translate(-14.554 -7.347)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.92,55.7a.42.42,0,0,1-.42-.42V51.92a.42.42,0,0,1,.84,0v3.359A.42.42,0,0,1,29.92,55.7Z",
    transform: "translate(-11.027 -11.195)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.92,55.7a.42.42,0,0,1-.42-.42V51.92a.42.42,0,0,1,.84,0v3.359A.42.42,0,0,1,33.92,55.7Z",
    transform: "translate(-11.668 -11.195)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.794,
    height: 5.038,
    rx: 2,
    transform: "translate(12.175 35.687)",
    fill: "#0593ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.4fca63cebe88079f84decdf1d3600fe7.svg";
export { ForwardRef as ReactComponent };